const slicesToPersist = ['data', 'quotes', 'misc'];

export default slicesToPersist;
